import styled from 'styled-components';

export const VerificationResultDetailsWrapper = styled.div`
	td, th {
		min-width: 11vw;
	}
`;